import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';
import { emitter } from 'shared/helpers/mitt';

export default {
  markMessagesRead: async ({ commit, dispatch, rootGetters }, data) => {
    try {
      const conversation = rootGetters.getConversationById(data.id);
      const previousUnread = conversation?.unread_count || 0;

      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);

      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount: 0,
      });

      if (previousUnread > 0 && conversation) {
        const currentUserId = rootGetters.getCurrentUser?.id;
        const assigneeId = conversation.meta?.assignee?.id;

        dispatch(
          'conversationStats/adjustUnreadOnRead',
          {
            inboxId: conversation.inbox_id,
            teamId: conversation.meta?.team?.id,
            amount: previousUnread,
            isMine: assigneeId === currentUserId,
          },
          { root: true }
        );
      }

      // Sidebar and chat list both listen to this and refresh their own scope.
      emitter.emit('fetch_conversation_stats');
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
      emitter.emit('fetch_conversation_stats');
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
